import React from "react";

import { SwingWorkspaceShell } from "@features/swing-trading/components/workspace-shell";

type Props = {
  children: React.ReactNode;
  freshness?: string;
};

export function PrivateNewsWorkspaceShell({ children, freshness }: Props): JSX.Element {
  const status = freshness === "current"
    ? "Current bundle"
    : freshness === "stale"
      ? "Stale bundle"
      : "No active bundle";

  return (
    <SwingWorkspaceShell
      title="Private news"
      description="Read sanitized newsletter source material from the active local bundle."
      meta={(
        <span className={`private-news-freshness private-news-freshness--${freshness || "unknown"}`}>
          {status}
        </span>
      )}
    >
      <main className="private-news-page">
        <div className="private-news-shell">{children}</div>
      </main>
    </SwingWorkspaceShell>
  );
}
